import React, { useState } from "react"
import { createContainer } from "unstated-next"
import IResult from "../models/result/IResult";
import * as voicifyApi from '../api';
import OrganizationVariable from "../models/organizations/OrganizationVariable";

function useOrganizationVariablesContainer() {
    const [organizationVariables, setOrganizationVariables] = useState([] as OrganizationVariable[]);
    const [selectedOrganizationVariable, setSelectedOrganizationVariable] = useState({} as OrganizationVariable);
    const [errors, setErrors] = useState([] as string[]);
    const [currentOrgId, setCurrentOrgId] = useState<string | null>(null);

    const loadOrganizationVariablesByOrganizationId = async (organizationId: string, baseUrl?: string): Promise<IResult<OrganizationVariable[]>> => {
        try {
            const result = await voicifyApi.getOrganizationVariablesByOrganizationId(organizationId, baseUrl);
            if (result.resultType == "Ok") {
                setOrganizationVariables(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const loadOrganizationVariableById = async (organizationVariableId: string): Promise<IResult<OrganizationVariable>> => {
        try {
            const result = await voicifyApi.getOrganizationVariableById(organizationVariableId);
            if (result.resultType == "Ok") {
                setSelectedOrganizationVariable(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const createOrganizationVariable = async (model: OrganizationVariable): Promise<IResult<OrganizationVariable>> => {
        try {
            const result = await voicifyApi.createOrganizationVariable(model);
            if (result.resultType == "Ok") {
                setOrganizationVariables([...organizationVariables, result.data]);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const updateOrganizationVariable = async (organizationVariableId: string, model: OrganizationVariable): Promise<IResult<OrganizationVariable>> => {
        try {
            const result = await voicifyApi.updateOrganizationVariable(organizationVariableId, model);
            if (result.resultType == "Ok") {
                const updatedVariables = organizationVariables.map(variable =>
                    variable.id === organizationVariableId ? result.data : variable
                );
                setOrganizationVariables(updatedVariables);
                setSelectedOrganizationVariable(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const deleteOrganizationVariable = async (organizationVariableId: string): Promise<IResult<OrganizationVariable>> => {
        try {
            const result = await voicifyApi.deleteOrganizationVariable(organizationVariableId);
            if (result.resultType == "Ok") {
                const filteredVariables = organizationVariables.filter(variable => variable.id !== organizationVariableId);
                setOrganizationVariables(filteredVariables);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const clearErrors = () => {
        setErrors([]);
    }

    return {
        organizationVariables,
        setOrganizationVariables,
        selectedOrganizationVariable,
        setSelectedOrganizationVariable,
        errors,
        setErrors,
        loadOrganizationVariablesByOrganizationId,
        loadOrganizationVariableById,
        createOrganizationVariable,
        updateOrganizationVariable,
        deleteOrganizationVariable,
        clearErrors,
        setCurrentOrgId
    };
}

const OrganizationVariablesContainer = createContainer(useOrganizationVariablesContainer);
export default OrganizationVariablesContainer;
